export default function (pid, planId, callback, duration) {
    const form = {
        pid,
        quantity: 1,
    };

    const addSubscriptionUrl = $('.add-subscription-url').val();
    const subscriptionMembershipUrl = $('.subscription-membership-url').val();

    if (addSubscriptionUrl) {
        $.ajax({
            url: addSubscriptionUrl,
            method: 'POST',
            data: form,
            success: (data) => {
                if (data.error) {
                    // show error
                } else if (subscriptionMembershipUrl) {
                    if (planId) {
                        location.href = `${subscriptionMembershipUrl}?planid=${planId}&duration=${duration}&stage=Membership`;
                    } else {
                        location.href = `${subscriptionMembershipUrl}?stage=Membership`;
                    }
                }
            },
            complete: () => {
                if (callback) {
                    callback();
                }
            },
            error: () => {},
        });
    }

    return false;
}
